module.exports = __webpack_public_path__ + "static/media/icon_10.8d880201.svg";